<template>
    <div class="page_container">
        <Banner v-if="bannerList.length > 0" :bannerList="bannerList" />
        <Content
            class="content"
            v-if="contentData"
            :contentData="contentData"
        />
        <FloatLayer
            v-if="floatAdvBanner.length > 0"
            :floatAdvBanner="floatAdvBanner"
        />
        <RightFloat :contactList="contactList" />
    </div>
</template>

<script>
import Banner from './components/Banner';
import Content from './components/Content';
import FloatLayer from '@/components/FloatLayer';
import RightFloat from '@/components/RightFloat';

export default {
    components: {
        Banner,
        Content,
        FloatLayer,
        RightFloat,
    },
    data() {
        return {
            // 轮播图列表
            bannerList: [],
            // 内容区数据
            contentData: null,
            // 悬浮广告图
            floatAdvBanner: [],
            // 右侧联系电话
            contactList: [],
        };
    },
    mounted() {
        // 获取数据
        this.getHomeData();
    },
    methods: {
        getHomeData() {
            this.$api.getHomeData({}).then((res) => {
                let homeData = res.data;
                this.bannerList = homeData[0];
                this.floatAdvBanner = homeData[1];
                let smallLeftBanner = homeData[2];
                let smallRightBanner = homeData[3];
                let {
                    workActivityList,
                    partyList,
                    noticeList,
                    messeageList,
                    newsList,
                    uploadList,
                } = homeData;
                this.contentData = {
                    smallLeftBanner,
                    smallRightBanner,
                    workActivityList,
                    partyList,
                    noticeList,
                    messeageList,
                    newsList,
                    uploadList,
                };
                // 右侧联系电话
                this.contactList = homeData.contactList;
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.page_container {
    min-width: 1110px;
    flex: 1;
    display: flex;
    flex-direction: column;
    .content {
        flex: 1;
    }
}
</style>
